<template>
	<van-popup v-model="show" class="department_dialog" :close-on-click-overlay="false">
		<div class="divider-row-one">
			<van-divider class="divider-item"> 医生个人介绍 </van-divider>
		</div>
		<div class="doctor-content">
			<img :src=" item.avatar " />
			<div class="name">{{ item.name }}</div>
			<div class="base-toast">{{ item.title }}</div>
			<div class="base-toast">{{ item.hospitalName }}</div>
		</div>

		<van-button class="mt-28" block round type="primary" @click="read">知道了</van-button>
	</van-popup>
</template>
<script>

export default {
    data () {
        return {}
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        item: {
            tyoe: Object,
            default: {}
        },
        goMain: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        show: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        async read () {
            this.show = false
            if (this.goMain) {
                this.$router.replace('/')
            }
        }
    }
}
</script>
<style scoped lang="less">
.department_dialog {
	background-image: url('../../../assets/img/department_dialog_bg.png');
	background-size: 100% auto;
	background-repeat: no-repeat;
	border-radius: 20px;
	width: 582px;
	padding: 40px;
}
.doctor-content {
	text-align: center;
	margin-bottom: 50px;
	img {
		width: 128px;
		height: 128px;
		overflow: hidden;
		border-radius: 64px;
		margin-bottom: 24px;
	}
	.name {
		font-size: 34px;
		color: #1f2329;
		margin-bottom: 14px;
	}
}
.doctor_list {
	max-height: 30vh;
	overflow: hidden;
	overflow-y: scroll;
}
.doctor_list_item {
	align-items: center;
	&-name {
		font-size: 30px;
		color: #1f2329;
		margin: 0 20px;
		font-weight: 500;
	}
	&-title_name {
		font-size: 24px;
		color: #8f959e;
	}
}
.avatar_image {
	height: 80px;
	width: 80px;
}
.base-toast {
	color: @gray-9;
	font-size: 26px;
	text-align: center;
	margin-top: 8px;
	line-height: 40px;
}
.divider-row {
	margin: 0 auto;
	width: 260px;
}
.divider-row-one {
	margin: 0 auto;
	width: 250px;
}
</style>
